/**
 * @fileOverview Menu
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires Local:overlay
 * @requires Polyfill:element-prototype-classlist 'Element.classList'
 */

import Overlay from './overlay';

/**
 * @module Menu
 */

export default {
  /**
   * Init the menu
   * @method initialization
   */
  initialization() {
    this.menu = document.querySelector( '.ac-menu' );
    this.btnMenu = document.querySelector( '.ac-menu-btn-menu' );
    this.menuList = document.querySelector( '.ac-menu-list' );
    this.isOpen = false;

    if ( this.btnMenu && this.menuList ) {

      const
        menu = document.getElementById( 'ac-menu' ),
        lvl1WithChildren = document.querySelectorAll(
          '.ac-menu-list__item--1.ac-menu-list__item--has-child'
        ),
        lvl1WithoutChild = document.querySelectorAll(
          '.ac-menu-list__item--1:not(.ac-menu-list__item--has-child)'
        ),
        menuListLvl1 = document.querySelector(
          '.ac-menu-list__lvl.ac-menu-list__lvl--1'
        );

      menu.addEventListener( 'click', e => {
        if ( e.target.closest( '.ac-menu-list__item--has-child > .ac-menu-list__link' )) {
          this.onClickMenuItemsOnMobile( e );
        } else if ( e.target.closest( '.ac-menu-list__link--back-link' )) {
          e.preventDefault();
          this.onClickItemsBackOnMobile( e );
        } else if ( e.target.closest( '.ac-menu-btn-menu' )) {
          e.preventDefault();
          this.onClickMenuButtonOnMobile( e );
        }
      });

      // Handle mouseenter for level 1 with children on big devices
      for ( let i = 0; i < lvl1WithChildren.length; i++ ) {
        lvl1WithChildren[ i ].addEventListener(
          'mouseenter',
          this.onMouseEnterItemsWithChildrenOnBigDevices.bind( this )
        );
      }

      // Handle mouseenter for level 1 without child on big devices
      for ( let i = 0; i < lvl1WithoutChild.length; i++ ) {
        lvl1WithoutChild[ i ].addEventListener(
          'mouseenter',
          this.onMouseEnterItemsWithoutChildOnBigDevices.bind( this )
        );
      }

      if ( menuListLvl1 ) {
        menuListLvl1.addEventListener(
          'mouseleave',
          this.onMouseLeaveMenuOnBigDevices.bind( this )
        );
      }
    }
  },

  /**
   * Open the menu on mobile
   * @method openMenu
   */
  openMenu() {
    if ( !this.isOpen ) {
      Overlay.create();
      this.menu.appendChild( Overlay.overlay );
      Overlay.show();
      this.btnMenu.classList.add( 'js-menu-is--open' );
      this.menuList.classList.add( 'js-menu-is--open' );
      //On Overlay click close the Menu
      Overlay.onOverlayClick( this.closeMenu.bind( this ));
      this.isOpen = true;
    }
  },

  /**
   * Close the menu on mobile
   * @method closeMenu
   */
  closeMenu() {
    if ( this.isOpen ) {
      Overlay.hide();
      this.btnMenu.classList.remove( 'js-menu-is--open' );
      this.menuList.classList.remove( 'js-menu-is--open' );
      this.isOpen = false;
    }
  },

  /**
   * Open submenu on mobile if the menu is open
   * @param {Object} e Event Object
   */
  openChild( e ) {
    const target = e.target.closest( '.ac-menu-list__item' );
    if ( window.matchMedia( '(max-width:992px)' ).matches ) {
      e.preventDefault();
      target.querySelector( '.ac-menu-list__lvl' )
        .classList.add( 'js-item-is--open' );
    }
  },

  /**
   * Close submenu on mobile if the menu is open
   * @param {Object} e Event Object
   */
  closeChild( e ) {
    e.target.parentElement.parentElement.classList.remove( 'js-item-is--open' );
  },

  /**
   * Click listener on menu button
   *
   * Open or Close the menu when the menu button is pressed
   * @method onClickMenuButtonOnMobile
   */
  onClickMenuButtonOnMobile() {
    this.isOpen ? this.closeMenu() : this.openMenu();
  },

  /**
   * Click listener on menu items when the menu is open on mobile
   *
   * @method onClickMenuItemsOnMobile
   */
  onClickMenuItemsOnMobile( e ) {
    if ( this.isOpen ) {
      this.openChild( e );
    }
  },

  /**
   * Click listener on item back button when the menu is open on mobile
   *
   * @method onClickItemsBackOnMobile
   */
  onClickItemsBackOnMobile( e ) {
    if ( this.isOpen ) {
      this.closeChild( e );
    }
  },

  /**
   * MouseEnter listener on item on big devices
   *
   * @method onMouseEnterOnBigDevices
   */
  onMouseEnterItemsWithChildrenOnBigDevices() {
    if ( window.matchMedia( '(min-width:992px)' ).matches ) {
      Overlay.create();
      this.menu.classList.add( 'js-menu-is--open' );
      this.menu.parentElement.appendChild( Overlay.overlay );
      Overlay.show();
    }
  },

  /**
   * MouseEnter listener on item without children on big devices
   *
   * @method onMouseEnterItemsWithoutChildOnBigDevices
   */
  onMouseEnterItemsWithoutChildOnBigDevices() {
    if ( Overlay.overlay ) {
      if ( window.matchMedia( '(min-width:992px)' ).matches ) {
        this.menu.classList.remove( 'js-menu-is--open' );
        Overlay.hide();
      }
    }
  },

  /**
   * Mouse Leave listener on menu on big devices
   *
   * @method onMouseLeaveMenuOnBigDevices
   */
  onMouseLeaveMenuOnBigDevices() {
    if ( Overlay.overlay ) {
      if ( window.matchMedia( '(min-width:992px)' ).matches ) {
        this.menu.classList.remove( 'js-menu-is--open' );
        Overlay.hide();
      }
    }
  }
}
